import { render, staticRenderFns } from "./NewsVideoConfig.vue?vue&type=template&id=26ecac42"
import script from "./NewsVideoConfig.vue?vue&type=script&lang=js"
export * from "./NewsVideoConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports